interface WordSeparatorProps {
  word?: string;
  variant?: 'default' | 'or' | 'and';
}

const WordSeparator = ({
  word,
  variant = 'default',
}: WordSeparatorProps): JSX.Element => {
  // Enhanced color scheme for better visual distinction
  const getVariantStyles = () => {
    switch (variant) {
      case 'or':
        return {
          labelClasses:
            'mr-2 px-3 py-1 border-2 border-orange-d-200 bg-orange-d-50 rounded-md text-orange-d-700 text-xs font-semibold uppercase tracking-wide',
          lineClasses: 'w-full h-0.5 bg-orange-d-200',
        };
      case 'and':
        return {
          labelClasses:
            'mr-2 px-3 py-1 border-2 border-primary-d-200 bg-primary-d-50 rounded-md text-primary-d-700 text-xs font-semibold uppercase tracking-wide',
          lineClasses: 'w-full h-0.5 bg-primary-d-200',
        };
      default:
        return {
          labelClasses:
            'mr-2 px-2 border border-dark-grey rounded text-dark-grey text-tiny uppercase',
          lineClasses: 'w-full h-px bg-light-grey',
        };
    }
  };

  const { labelClasses, lineClasses } = getVariantStyles();

  return (
    <div className="flex items-center my-4">
      {word && <span className={labelClasses}>{word}</span>}
      <div className={lineClasses} />
    </div>
  );
};

export default WordSeparator;
